import { render, staticRenderFns } from "./KlinikTashPechat.vue?vue&type=template&id=4b2094cf"
import script from "./KlinikTashPechat.vue?vue&type=script&lang=js"
export * from "./KlinikTashPechat.vue?vue&type=script&lang=js"
import style0 from "./KlinikTashPechat.vue?vue&type=style&index=0&id=4b2094cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports